import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { GroupSelector } from './GroupSelector';
import { Celebs } from './Lists/Celebs';
import { ListAvatars } from './Lists/ListAvatars';
import { ListHistory } from './Lists/ListHistory';
import { ListAvatarsLayout } from './Lists/ListAvatarsLayout';
import { ListCity } from './Lists/ListCity';
import { Map } from './Lists/PeopleMap/PeopleMap';
import { Pentas, PentasTitle } from './Penta/Pentas';
import { SocialVIewSettings } from './SocialVIewSettings';
import { Button } from './UiKit/Button';
import { CreateNew } from './UiKit/CreateNew';
import { MeChecklistSocial } from './UiKit/MeChecklist';
import { SocialChoose } from './UiKit/SocialChoose';
import { SocialTabs } from './UiKit/SocialTabs';
import { WithVersion } from './UiKit/VersionToggler';
import { WithGroup } from './WithGroup';
import { parseAvatar, sortBy, filterHistoryTokens } from './utilsDesign';
import { Lists } from './Lists';
import { ListTypes } from './ListTypes';
import { SocialFilters, filterArrayByStats, matchesStatsFilter } from './UiKit/SocialFilters';
import { PentaFolder } from './Penta/PentaFolder/PentaFolder';
import { Persona } from './Persona';
import { GroupInfo } from './GroupInfo';
import { GroupMembers } from './GroupMembers';

const Social = memo((props) => {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui || (() => '');
  const panelExpanded = context.state.peoplePanel;
  const panelExpandedBool = Boolean(panelExpanded);
  const PANEL_TRANSITION_MS = 300;

  const [panelExpandedInner, setPanelExpandedInner] = useState(panelExpandedBool);

  const navigate = useNavigate();

  const {
    children,
    peopleShown = false,
    hidePreviews,
    mode = 'hd',
    showItems = [
      'world',
      'people',
      'history',
      'bodygraphs',
      'pentas',
    ]
  } = { ...props };
  const [searchParams] = useSearchParams();






  const [penta, setPenta] = useState();
  const [pentaId2, setPentaId2] = useState();
  const [pentaAvatars, setPentaAvatars] = useState();

  const [groupBrowser, setGroupBrowser] = useState();

  const [filter, setFilter] = useState(mode === 'hd' ? 'types' : 'yoni');
  const [statsFilter, setStatsFilter] = useState(null);

  const [tab, setTab] = useState();

  const filterPeople = (array, filterKey) => {
    if (!array) return null;
    return sortBy(array, filterKey);
  };




  const [socialView, setSocialViewInner] = useState(panelExpanded
    ? panelExpanded
    : ['bodygraphs']
    // : ['people', 'followers']
  )
  // const [socialView, setSocialViewInner] = useState(['world', 'people', 'followers', 'bodygraphs'])

  const setSocialView = (what, hover) => {
    // console.log('what = ', what);
    // if (socialView.includes(what)) {
    //   setSocialViewInner(prev => prev.filter(one => one !== what))
    // } else {
    //   setSocialViewInner(prev => [...prev, what])
    // }
    // console.log('what = ', what);
    if (hover) {
      setSocialViewInner(what)
      // context.x.setCurrentPeopleSet(['what'])
    } else {
      setPanel(what)
    }
  }


  const sortedFollowings = useMemo(() => {
    if (!context.followings) return undefined;
    // Dense list for UI/filters; keep `_listIndex` on items for page hydrate.
    // Exclude me from the API list — same sticky prepend pattern as sortedAvatars.
    const meUserToken = context.me?.user?.token;
    return [
      context.me,
      ...context.followings.filter(
        (one) => one && one?.user?.token !== meUserToken
      ),
    ].filter(Boolean);
  }, [context.followings, context.me]);

  const sortedFollowers = useMemo(() => {
    const followers = Array.isArray(context.followers) ? context.followers.filter(Boolean) : [];
    const followings = Array.isArray(context.followings) ? context.followings : [];

    let arr = followers;
    if (followings.length > 0) {
      const followingTokens = new Set(
        followings.map(item => item?.user?.token).filter(Boolean)
      );
      arr = followers.filter(item => !followingTokens.has(item?.user?.token));
    }

    return sortBy(arr, filter);
  }, [context.followers, context.followings, filter]);

  const meAvatarToken = context.me?.avatar?.token;
  const sortedAvatars = !context.avatars ? null : [
    context.me,
    ...context.avatars.filter(one => one?.avatar?.token && one.avatar.token !== meAvatarToken),
  ].filter(Boolean);

  const sortedAvatarsList = useMemo(() => {
    if (!sortedAvatars) return [];
    // return sortBy([...sortedAvatars], filter);
    return sortedAvatars
  }, [context.avatars, context.me, filter]);

  const applyListStatsFilter = useCallback((array, listId) => {
    if (!statsFilter || statsFilter.listId !== listId) return array;
    return filterArrayByStats(array, statsFilter);
  }, [statsFilter]);

  const filteredFollowings = useMemo(
    () => applyListStatsFilter(sortedFollowings, 'followings'),
    [sortedFollowings, applyListStatsFilter]
  );

  const filteredAvatarsList = useMemo(
    () => applyListStatsFilter(sortedAvatarsList, 'avatars'),
    [sortedAvatarsList, applyListStatsFilter]
  );


  const peoplePanelRef = useRef(null);
  const panelContentHidden = panelExpandedBool !== panelExpandedInner;

  useEffect(() => {
    let timer;
    if (panelExpandedBool) {
      setPanelExpandedInner(false);
      timer = setTimeout(() => setPanelExpandedInner(true), PANEL_TRANSITION_MS);
    } else {
      timer = setTimeout(() => setPanelExpandedInner(false), PANEL_TRANSITION_MS);
    }
    return () => clearTimeout(timer);
  }, [panelExpandedBool]);

  useEffect(() => {
    if (panelExpandedInner && panelExpanded && panelExpanded[0] !== socialView[0]) {
      // peoplePanelRef.current.scrollTop = 0;
      setSocialViewInner(panelExpanded)
    }
  }, [panelExpandedInner, panelExpanded]);


  useEffect(() => {
    setStatsFilter(null);
  }, [socialView, filter]);

  // HASH
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    const panel = params.get('p');
    if (panel) {
      // `p` holds a comma separated list, and the rest of the panel logic works
      // with arrays — a raw string would break `socialView.includes(...)`.
      const panelList = panel.split(',').filter(Boolean);
      const current = context.state.peoplePanel;
      const sameAsCurrent = Array.isArray(current)
        && current.length === panelList.length
        && current.every((one, ind) => one === panelList[ind]);
      if (!sameAsCurrent) {
        context.setState.showPeoplePanel(panelList)
        setSocialViewInner(panelList)
      }
    }
    const group = params.get('g');
    if (group) {
      setTab(group)
    } else {
      setTab('all')
    }

  }, [location]);

  const setPanel = (newPanel) => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    if (newPanel) {
      params.set('p', newPanel); // Set the new language parameter
      const newHash = params.toString();
      window.history.replaceState(null, '', `${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
      context.setState.showPeoplePanel(newPanel);
      setSocialViewInner(newPanel)
    } else {
      params.delete('p');
      const newHash = params.toString();
      window.history.replaceState(null, '', `${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
      context.setState.showPeoplePanel()
    }
  };


  const setPeoplePanel = (newPanel, group) => {
    const hash = location.hash.substring(1); // Remove the leading '#'
    const params = new URLSearchParams(hash);
    if (newPanel) {
      params.set('p', newPanel); // Set the new panel parameter
      context.setState.showPeoplePanel(newPanel);
    } else {
      params.delete('p');
      context.setState.showPeoplePanel();
    }
    if (group && group !== 'all') {
      params.set('g', group);
    } else {
      params.delete('g');
    }
    const newHash = params.toString();
    navigate(`${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
  };


  const peoplePanelScrollable = useRef(null);
  const scrollToTop = (y = 0) => {
    if (peoplePanelScrollable.current) {
      peoplePanelScrollable.current.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  const handleStatsSelect = (listId) => (match) => {
    setStatsFilter((prev) => {
      if (match.profile) {
        const sameProfile = prev?.listId === listId
          && prev?.type === match.type
          && prev?.profile?.[0] === match.profile[0]
          && prev?.profile?.[1] === match.profile[1];
        if (sameProfile) {
          return { listId, type: match.type };
        }
        return { listId, type: match.type, profile: match.profile };
      }
      if (match.type) {
        if (prev?.listId === listId && prev?.type === match.type) {
          return null;
        }
        return { listId, type: match.type };
      }
      if (prev?.listId === listId && matchesStatsFilter(prev, match)) {
        return null;
      }
      return { listId, ...match };
    });
  };

  const clearStatsFilter = useCallback(() => setStatsFilter(null), []);

  const toggleStatsMode = useCallback(() => {
    setFilter((prev) => (prev === 'types' ? 'profiles' : 'types'));
  }, []);

  const clearHistory = () => {
    context.setState.setShowHistory(null, null, true, context.me?.user?.token)
    // navigate(`/${context.me.user.token}`)
  }

  const menu = [
    {
      id: 'world',
      icon: 'travel_explore',
      handleValue: ['world'],
      title: context.myCity?.city || 'people_city',
    },
    {
      id: 'people',
      icon: 'group',
      handleValue: ['people', 'followers'],
      title: 'people_people',
    },
    // {
    //   withVersion: true,
    //   id: 'celebs',
    //   icon: 'star',
    //   handleValue: ['celebs'],
    //   title: 'people_celebs',
    // },
    {
      id: 'bodygraphs',
      icon: 'person_search',
      handleValue: ['bodygraphs'],
      title: 'people_bodygraphs',
    },
    {
      id: 'history',
      icon: 'history',
      handleValue: ['history'],
      title: 'people_history'
    },
    {
      id: 'div1',
      divider: true
    },
    {
      // withVersion: true,
      id: 'pentas',
      icon: 'diversity_3',
      handleValue: ['pentas'],
      // addHandler: () => {
      //   context.setState.setPentaFolders(!context.state.pentaFolders)
      // },
      title: 'people_synergy',
    },
  ]

  const filteredMenu = menu
    .filter(one => one.divider || showItems.includes(one.id))
    // drop dividers that ended up first, last, or next to another divider
    .filter((one, ind, arr) => !one.divider || (ind > 0 && ind < arr.length - 1 && !arr[ind - 1].divider));


  const updateGParam = (newGValue) => {
    const hash = location.hash.substring(1);
    const params = new URLSearchParams(hash);
    params.set('g', newGValue);
    const newHash = params.toString();
    navigate(`${location.pathname}${location.search}#${newHash}`);
  };

  const followingsCount = context.me?.user?.aggr?.followings_count || 0;
  const meUserToken = context.me?.user?.token;
  const loadedFollowings = Array.isArray(context.followings)
    ? context.followings.filter(
      (one) => one && one?.user?.token !== meUserToken
    ).length
    : 0;
  // Clamp to loaded length only once the full list is in memory (desktop prefetch).
  // On mobile we keep aggr-based quantity so page nav can fetch the rest.
  // +1 for sticky me (excluded from loadedFollowings above).
  const followingsListQuantity = context.followingsComplete
    ? loadedFollowings + (context.me ? 1 : 0)
    : followingsCount + (context.me ? 1 : 0);
  const followingsHeaderQuantity = followingsListQuantity;
  const avatarsLength = context.me?.user?.aggr?.avatars_count || 0;
  // console.log('context.me.user.aggr = ', context.me.user.aggr);
  // console.log('avatarsLength = ', avatarsLength);


  const createAvatar = () => !context.creatingAva && context.x.createAvatar(
    null,
    (newAvatar) => {
      setPeoplePanel(false);
      navigate(`/u/${newAvatar.token}`);
    }
  )

  return (
    <>

      <div className={panelExpanded ? "x_people0 active" : "x_people0"}>


        {!panelExpanded && <SocialChoose
          mode={mode}
          view='left'
          handle={(what) => {
            setSocialView(what)
            if (what && what.length && !panelExpanded) context.setState.showPeoplePanel(what)
            // context.setState.showPeoplePanel([])
          }}
          handleHover={(a) => {
            setSocialView(a, 'hover')
          }}
          active={socialView}
          options={filteredMenu}
        />}






        <div className={`${!panelExpanded ? `${hidePreviews ? 'x_choose_panel x_choose_panel--penta' : 'x_choose_panel'}` : "x_choose_panel active"}`}>
          <div className={panelExpanded ? "x_choose0 active" : `${hidePreviews ? 'x_choose0 x_choose0--penta' : 'x_choose0'}`}>


            <div ref={peoplePanelRef} className={panelExpanded ? "x_people_panel active" : `${hidePreviews ? 'x_people_panel x_people_panel--penta' : 'x_people_panel'}`}>


              <div
                className={!panelExpanded ? "x_choose_left" : "x_choose_left x_choose_left--open"}
              // className={"x_choose_left"}
              >


                {/* {panelExpanded &&
                  mode === 'hd' &&
                  !socialView.includes('pentas') &&
                  !socialView.includes('history') &&
                  <SocialVIewSettings filter={filter} setFilter={setFilter} />
                } */}



                {/* {!panelExpanded &&  */}
                <div className={`${panelContentHidden ? 'x_choose_panel_hidden ' : ''}${panelExpanded ? "x_choose_container x_choose_container--v " : "x_choose_container"}`} ref={peoplePanelScrollable}>


                  <div className={panelExpanded ? "x_panel_h x_panel_h--people active" : "x_panel_h x_panel_h--people"}>


                    {/* {!panelExpanded && <div className="x_action" onClick={() => context.setState.showPeoplePanel(true)}>
                      <div className="t_icon t_icon--20">
                        <div>chevron_right</div>
                      </div>
                    </div>} */}






                    {/* {context.me && panelExpanded && <div className="x_panel_friends_title">
                      <div className="x_panel_icon">
                        <div className="t_icon t_icon--20">
                          <div>people</div>
                        </div>
                      </div>
                      <div className="x_panel_title active">
                        {$ui('people_header')}
                      </div>
                    </div>} */}



                    <SocialChoose
                      handle={setSocialView}
                      active={socialView}
                      options={filteredMenu}
                    />

                    {/* <MobMenu
                      active={socialView}
                      avatar={context.state.showHistory[0].avatar}
                    /> */}



                    {panelExpanded && <>
                      {/* <div className="x_panel_actions x_panel_actions--sub">
                        <Checkbox label={$ui('p_toggles_city')} value={socialView.includes('world')} handle={() => setSocialView('world')} />
                        <Checkbox label={$ui('p_toggles_people')} value={socialView.includes('people')} handle={() => setSocialView('people')} />
                        <Checkbox label={$ui('p_toggles_folowers')} value={socialView.includes('followers')} handle={() => setSocialView('followers')} />
                        <Checkbox label={$ui('p_toggles_bodygraphs')} value={socialView.includes('bodygraphs')} handle={() => setSocialView('bodygraphs')} />
                      </div> */}
                      <div className="mobile_v_no">
                        <div className="x_panel_actions">
                          <div className="x_action"
                            // onClick={(prev) => context.setState.showPeoplePanel()}
                            onClick={() => setPanel()}
                          >
                            <div className="t_icon t_icon--60">
                              <div>close</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>}
                  </div>


                  <div className="x_panel_h0" />

                  <div className={[
                    hidePreviews && !panelExpanded ? "x_choose_contents x_choose_contents--penta" : "x_choose_contents",
                    panelContentHidden ? "x_choose_contents--panel_animating" : "",
                  ].filter(Boolean).join(' ')}>



                    <div className="x_choose_sect0">

                      {panelExpanded
                        && (socialView.includes('world') || socialView.includes('people'))
                        && context.me
                        && (!context.me.user.city_id || !context.me.avatar.image || !context.me.avatar.name)
                        && <MeChecklistSocial 
                          user={context.me.user} 
                          avatar={context.me.avatar}
                          addClassName='x_user_checklist0--choose'
                        >
                          <div className="x_click"
                            onClick={() => (context.me.avatar.image && context.me.avatar.name) ? navigate(`/u/${context.me.user.token}#p=world`) : navigate(`/u/${context.me.user.token}/info`)}
                          />
                        </MeChecklistSocial>}



                      {!panelExpanded && showItems.includes('world') && socialView.includes('world') && <>
                        <ListCity user={context.me.user}
                          filterPeople={filterPeople}
                          filter={filter}
                          mode={mode}
                        />
                        {/* {socialView.includes('world') && <Celebs />} */}
                        </>
                      }
                      {panelExpanded && showItems.includes('world') && socialView.includes('world') && <>
                        <Map user={context.me.user}
                          filterPeople={filterPeople}
                          filter={filter}
                        />
                        {/* {socialView.includes('world') && <Celebs />} */}
                        </>
                      }

                      {showItems.includes('history') && socialView.includes('history')
                        && <ListAvatarsLayout
                          className={panelExpanded ? 'v' : ''}
                          icon='history'
                          title={$ui('people_history')}
                          listId='history'
                          quantity={filterHistoryTokens(context.state.showHistory).length}
                          privateList={true}
                          addLeft={<Button ghost onClick={() => clearHistory()}>{$ui('people_history_clear')}</Button>}
                        >
                          <ListHistory
                            mode={mode}
                            scrollToTop={scrollToTop}
                          />
                        </ListAvatarsLayout>}



                      {showItems.includes('people') && socialView.includes('people') && <>


                        
                          {panelExpanded
                            && Boolean(context.groups?.length)
                            && <SocialTabs
                              active={tab}
                              handleChange={newG => {
                                setPeoplePanel(['people', 'followers'], newG)
                              }}
                            />
                          }
                        

                        {tab === 'all'
                          // && context.followings
                          && <>
                            <ListAvatarsLayout
                              icon='group'
                              title={$ui('people_people')}
                              listId='people'
                              quantity={followingsHeaderQuantity}
                              className={panelExpanded ? 'v' : ''}
                              addLeft={<SocialFilters
                                mode={mode}
                                type={filter}
                                array={sortedFollowings || []}
                                onSelect={handleStatsSelect('followings')}
                                activeFilter={statsFilter?.listId === 'followings' ? statsFilter : null}
                                onClear={clearStatsFilter}
                                onToggleMode={mode === 'hd' ? toggleStatsMode : undefined}
                                ready={Boolean(context.followingsComplete)}
                              />}
                              // addRight={<Button ghost onClick={() => {
                              //   setPanel();
                              //   navigate(`/u/${context.me.user.token}/info`);
                              // }}>
                              //   {$ui('but_edit_profile')}
                              // </Button>}
                            >
                              {/* <ListAvatars
                                scrollToTop={scrollToTop}
                                listId='me'
                                quantity={1}
                                array={[context.me]}
                                actions={['edit', 'share']}
                              /> */}
                              <ListAvatars
                                mode={mode}
                                scrollToTop={scrollToTop}
                                listId='followings'
                                quantity={statsFilter?.listId === 'followings' ? (filteredFollowings?.length || 0) : followingsListQuantity}
                                array={filteredFollowings}
                                // array={filterPeople(context.followings, filter)}
                                // array={context.followings}
                                actions={['share', 'follow']}
                                celeb={true}
                                // createNew={<CreateNew
                                //   icon='search'
                                //   label={$ui('people_find_more')}
                                //   handle={() => setSocialView('world')}
                                // />}
                                paginate={context.state.paginate}
                              />
                            </ListAvatarsLayout>



                            {/* {socialView.includes('followers') &&
                              <ListAvatarsLayout
                                icon='public'
                                title={$ui('people_followers')}
                                listId='followers'
                                addLeft={<SocialFilters type={filter} array={sortedFollowers} onSelect={handleStatsSelect('followers')} />}
                                quantity={sortedFollowers.length}
                                className={panelExpanded ? 'v' : ''}
                              >

                                <ListAvatars
                                  scrollToTop={scrollToTop}
                                  listId='followers'
                                  quantity={sortedFollowers.length}
                                  array={sortedFollowers}
                                  emptyMessage={$ui('people_social_empty')}
                                  actions={['follow']}
                                  celeb={true}
                                  paginate={context.state.paginate}
                                  scrollTarget={scrollTarget}
                                  onScrollTargetHandled={clearScrollTarget}
                                />
                              </ListAvatarsLayout>
                            } */}

                          </>}

                        <WithVersion>
                          {panelExpanded && tab && tab !== 'all' && (
                            <div className="x_group_layout">
                              <WithGroup
                                id={tab}
                                key={tab}
                              >
                                <GroupSelector
                                  expanded={groupBrowser}
                                  setExpanded={setGroupBrowser}
                                />
                                <GroupInfo
                                  {...props}
                                  groupBrowser={groupBrowser}
                                  setGroupBrowser={setGroupBrowser}
                                />
                                <GroupMembers fullSrceen mode={mode} />
                              </WithGroup>
                            </div>
                          )}
                        </WithVersion>

                      </>}


                      {showItems.includes('bodygraphs') && socialView.includes('bodygraphs')
                        && <ListAvatarsLayout
                          title={$ui('people_bodygraphs')}
                          listId='avatars'
                          icon='person_search'
                          quantity={avatarsLength}
                          className={panelExpanded ? 'v' : ''}
                          addLeft={<>
                            <Button sm icon='add' onClick={createAvatar}>
                              <span className='mobile_v_no'>
                                {$ui('button_create_new')}
                              </span>
                            </Button>
                            <div className="x_choose_section_header_left_inner _fgap14">
                              <SocialFilters
                                mode={mode}
                                type={filter}
                                array={sortedAvatarsList}
                                onSelect={handleStatsSelect('avatars')}
                                activeFilter={statsFilter?.listId === 'avatars' ? statsFilter : null}
                                onClear={clearStatsFilter}
                                onToggleMode={mode === 'hd' ? toggleStatsMode : undefined}
                              />
                            </div>
                          </>}
                          privateList={true}
                        >
                          <ListAvatars
                            mode={mode}
                            scrollToTop={scrollToTop}
                            celeb={false}
                            quantity={statsFilter?.listId === 'avatars' ? filteredAvatarsList.length : avatarsLength}
                            listId='avatars'
                            array={filteredAvatarsList}
                            actions={[
                              'edit',
                              // 'setMe',
                              'delete']}
                            createNew={<CreateNew
                              icon='add'
                              label={$ui('button_create_new_bodygraph')}
                              handle={createAvatar}
                              loading={context.creatingAva}
                            />}
                            paginate={context.state.paginate}
                          />

                        </ListAvatarsLayout>}



                      {showItems.includes('pentas') 
                        && !context.state.pentaFolders
                        && socialView.includes('pentas')
                        && context.pentas
                        && <>
                          <Pentas
                            icon='group'
                            title={$ui('people_composites')}
                            max={2}
                            min={0}
                            create={true}
                            mode={mode}
                          />

                          <WithVersion><>
                            <Pentas
                              icon='diversity_3'
                              title={$ui('people_pentas')}
                              min={3}
                              max={5}
                              mode={mode}
                            />

                            <PentaFolder
                              icon='diversity_3'
                              title={$ui('people_va')}
                              min={6}
                              max={10}
                              mode={mode}
                            />
                          </>
                          </WithVersion>
                        </>
                      }

                      {showItems.includes('pentas') 
                        && context.state.pentaFolders
                        && socialView.includes('pentas')
                        && context.pentas
                        && <>
                            <PentaFolder
                              icon={false}
                              title={false}
                              min={0}
                              max={1000}
                              mode={mode}
                            >
                              <PentasTitle icon='diversity_3' title={$ui('people_composites')} count={context.pentas.length} create={true} />
                            </PentaFolder>
                        </>
                      }



                      {/* {socialView.includes('pentas') && <ListAvatarsLayout
                        title={$ui('people_composites')}
                        listId='pentas'
                        icon='diversity_3'
                        quantity={context.avatars.length - 1}

                      >
                        <Pentas />
                        <CreateNew
                          icon='add'
                          label={$ui('button_create_new_bodygraph')}
                          handle={() => !context.creatingAva && context.x.createAvatar(
                            (newUrl) => {
                              navigate(`/u/${newUrl}`)
                            }
                          )}
                          loading={context.creatingAva}
                        />
                      </ListAvatarsLayout>} */}


                      {/* {context.pentas
                        && !context.pentas.length
                        && <Preloader0 style={{ paddingTop: '4em' }}>
<Preloader width={80} height={80} />
</Preloader0>} */}






                    </div>
                  </div>



                </div>
                {/* } */}


              </div>


            </div>
            {panelExpanded && <div className="x_choose_bg">
              <div className="x_edu_bg g" />
            </div>}



            {/* <WithVersion>{panelExpanded && <Pentas />}</WithVersion> */}



          </div>
        </div>

        {panelExpanded && <div
          className="x_choose_z"
          onClick={() => setPanel()}
        >
        </div>}


      </div>






      {/* <ListPersonas title='Pentas' quantity={context.pentas.length}>
        {context.pentas.map((one, ind) => <div key={`penta_${ind}`}>
          <Persona
            name={one.name}
          />
        </div>)}
      </ListPersonas> */}



      {/* <ListAvatarsLayout title='Groups' quantity={context.groups?.length}>
        {context.groups?.map((one, ind) => <div key={`penta_${ind}`}>
          <Persona
            {...one}
            name={one.name}
          />
        </div>)}
      </ListAvatarsLayout> */}


    </>
  )
})

export default Social;
